import React, { Component } from 'react';
import ReactPlayer from 'react-player';

import '../../../../../chat.css';

/**
 * A message type that shows a video.
 * Uses the ReactPlayer component. 
 * https://github.com/CookPete/react-player
 */
class VideoMessage extends Component {
    render() {
        return(
            <div className={'video-message-container content-overlay-container'}>
                <ReactPlayer url={this.props.url} playing={this.props.autoPlay === false ? false : true} 
                             loop={this.props.loop === false ? false : true} controls={this.props.showControls === true}
                             width={'100%'} height={'100%'} volume={0.5} muted={false}></ReactPlayer>
            </div>
        );
    }
}

export default VideoMessage;
